import { PermissionsEnum } from '@uikit/Tables/TableDynamic/constants';

export const getIsPermissionToggleEnabled = (): boolean => {
  const value = window.localStorage.getItem('PTA');
  return value ? JSON.parse(value) : false;
};

export const getPermissionAbilityId = (
  field: string
): PermissionsEnum | undefined => {
  const permissionFieldMap: Partial<Record<string, PermissionsEnum>> = {
    read: PermissionsEnum.Read,
    create: PermissionsEnum.Create,
    edit: PermissionsEnum.Edit,
    audit: PermissionsEnum.Audit,
    document: PermissionsEnum.Special,
    special: PermissionsEnum.Special,
  };
  return permissionFieldMap[field.toLowerCase()];
};
